import type {ReactElement} from 'react';
import {TransitionablePanelV2} from '@Panels/transitionable-panel-v2/transitionable-panel-v2';
import {IconShape} from '@Components/icon-v2/icon.types';
import type {CheckoutFlowPanelProps} from '@Components/checkout-flow/checkout-flow.types';
import {useCheckoutFlow} from '@Components/checkout-flow/checkout-flow.hooks';
import {CheckoutFlowContent} from '@Components/checkout-flow/components/checkout-flow-content/checkout-flow-content';
import {CheckoutFlowHeader} from '@Components/checkout-flow/components/checkout-flow-header/checkout-flow-header';
import styles from './checkout-flow.module.scss';

export function CheckoutFlowPanel({request, panelId, modalId, onExit}: CheckoutFlowPanelProps): ReactElement {
  const flow = useCheckoutFlow(request, {onExit});

  return (
    <TransitionablePanelV2
      panelId={panelId}
      modalId={modalId}
      content={<CheckoutFlowContent flow={flow} />}
      header={<CheckoutFlowHeader flow={flow} />}
      contentKey={flow.contentKey}
      transitionDirection={flow.transitionDirection}
      isLoading={flow.isLoading}
      closeIconShape={IconShape.CIRCLE}
      closeIconClassName={styles.closeIcon}
      hideCloseIcon={!flow.showsPanelCloseIcon}
      onModalClose={flow.controller.exit}
      animateHeightOnResize
      growOnlyWithinStep
      isScrollable
      hideSeeMorePill
    />
  );
}
